import style from "./ProfileTabs.module.css";

import { NavLink } from "react-router-dom";
import Icon from "@/ui/icon/Icon";

import { useGetUserSavedCourses } from "../../hooks/useGetUserSavedCourses";
import { useGetUserLikedVideos } from "../../hooks/useGetUserLikedVideos";

import { padZero } from "@/utils/helpers";

function ProfileTabs({ username }) {
	const { courses, isPending: savedIsPending } =
		useGetUserSavedCourses(username);
	const { likedVideos, isPending: likedIsPending } =
		useGetUserLikedVideos(username);

	// return skelton here
	if (savedIsPending && likedIsPending) return <></>;

	return (
		<nav className={style.tabs}>
			<ul>
				<li>
					<NavLink to={`/u/${username}`} end>
						<Icon icon="fa-bookmark" />
						<span>Sačuvani kursevi</span>
						{courses?.length > 0 && (
							<span className={style.badge}>
								{padZero(courses?.length)}
							</span>
						)}
					</NavLink>
				</li>
				<li>
					<NavLink to="liked-videos">
						<Icon icon="fa-heart" />
						<span>Omiljeni videi</span>
						{likedVideos?.length > 0 && (
							<span className={style.badge}>
								{padZero(likedVideos?.length)}
							</span>
						)}
					</NavLink>
				</li>
			</ul>
		</nav>
	);
}

export default ProfileTabs;
